/* ==========================================================================
   AJ FITS — Frequently bought together
   Keeps the running total in step with the checkboxes and size pickers,
   then adds every selected line in one request.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function money(cents) {
    if (window.AJ && window.AJ.formatMoney) return window.AJ.formatMoney(cents);
    return '₹' + Math.round(cents / 100);
  }

  /* Falls back to "no cap" if aj-stock.js is missing; Shopify still guards. */
  var stockStub = {
    remaining: function () { return Infinity; },
    inCart: function () { return 0; },
    message: function () { return 'That is all we have in stock.'; },
    refresh: function () {},
    friendlyError: function (err) { return (err && err.message) || 'Could not add'; }
  };

  function stockApi() {
    return (window.AJ && window.AJ.stock) || stockStub;
  }

  function init(root) {
    $$('[data-aj-fbt]', root).forEach(function (box) {
      if (box.dataset.ajFbtReady) return;
      box.dataset.ajFbtReady = '1';

      var totalEl = $('[data-aj-fbt-total]', box);
      var addBtn = $('[data-aj-fbt-add]', box);
      var items = $$('.aj-fbt__item', box);

      function lines() {
        var out = [];
        items.forEach(function (item) {
          var check = $('[data-aj-fbt-check]', item);
          if (!check || !check.checked) return;

          // A size picker overrides the default variant on that row
          var size = $('[data-aj-fbt-size]', item);
          var chosen = size ? size.options[size.selectedIndex] : null;
          var id = size ? size.value : check.dataset.variant;
          var price = chosen ? Number(chosen.dataset.price) : Number(check.dataset.price);
          var stockMax = chosen ? chosen.dataset.stockMax : check.dataset.stockMax;

          if (id) out.push({ id: Number(id), price: price || 0, stockMax: stockMax });
        });
        return out;
      }

      function sync() {
        var picked = lines();
        var total = picked.reduce(function (sum, l) { return sum + l.price; }, 0);
        if (totalEl) totalEl.textContent = money(total);
        if (addBtn) {
          addBtn.disabled = picked.length === 0;
          addBtn.classList.toggle('is-disabled', picked.length === 0);
        }
      }

      box.addEventListener('change', function (e) {
        if (e.target.closest('[data-aj-fbt-check], [data-aj-fbt-size]')) sync();
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var picked = lines();
          if (!picked.length) return;

          // Drop any line the shelf cannot cover, and say which one.
          var stock = stockApi();
          var blocked = [];
          picked = picked.filter(function (line) {
            if (stock.remaining(line.id, line.stockMax) >= 1) return true;
            blocked.push(line);
            return false;
          });

          if (blocked.length && window.AJ && window.AJ.toast) {
            var first = blocked[0];
            window.AJ.toast(stock.message(first.stockMax, stock.inCart(first.id)), { type: 'error' });
          }
          if (!picked.length) return;

          addBtn.disabled = true;
          var original = addBtn.innerHTML;
          addBtn.textContent = 'Adding…';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: picked.map(function (l) { return { id: l.id, quantity: 1 }; })
            })
          })
            .then(function (r) {
              return r.json().then(function (data) {
                if (!r.ok) throw new Error(data.description || data.message || 'Could not add');
                return data;
              });
            })
            .then(function () {
              if (window.AJ && window.AJ.cart) window.AJ.cart.refreshBadge();
              if (window.AJ && window.AJ.toast) {
                window.AJ.toast(picked.length + ' item' + (picked.length === 1 ? '' : 's') + ' added', {
                  action: { href: '/cart', label: 'View cart' }
                });
              }
              var drawer = document.querySelector('cart-drawer');
              if (drawer) {
                fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
                  .then(function (r) { return r.json(); })
                  .then(function (sections) {
                    if (typeof drawer.renderContents === 'function') {
                      drawer.renderContents({ sections: sections, sections_html: sections });
                    }
                  })
                  .catch(function () {});
              }
            })
            .catch(function (err) {
              if (window.AJ && window.AJ.toast) {
                window.AJ.toast(stock.friendlyError(err), { type: 'error' });
              }
              stock.refresh();
            })
            .finally(function () {
              addBtn.disabled = false;
              addBtn.innerHTML = original;
            });
        });
      }

      sync();
    });
  }

  function boot() { init(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
